import { safeExecute } from "@opendaw/lib-std";
import { Box, NoPointers, PointerField, Int32Field, Float32Field, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class WarpMarkerBox extends Box {
    static create(graph, uuid, constructor) {
        return graph.stageBox(new WarpMarkerBox({
            uuid,
            graph,
            name: "WarpMarkerBox",
            pointerRules: {
                accepts: [Pointers.Selection],
                mandatory: false,
                exclusive: false,
            },
        }), constructor);
    }
    static ClassName = "WarpMarkerBox";
    constructor(construct) {
        super(construct);
    }
    accept(visitor) {
        return safeExecute(visitor.visitWarpMarkerBox, this);
    }
    get owner() {
        return this.getField(1);
    }
    get position() {
        return this.getField(2);
    }
    get seconds() {
        return this.getField(3);
    }
    initializeFields() {
        return {
            1: PointerField.create({
                parent: this,
                fieldKey: 1,
                fieldName: "owner",
                deprecated: false,
                pointerRules: NoPointers,
            }, Pointers.WarpMarkers, true),
            2: Int32Field.create({
                parent: this,
                fieldKey: 2,
                fieldName: "position",
                deprecated: false,
                pointerRules: NoPointers,
            }, "any", "ppqn"),
            3: Float32Field.create({
                parent: this,
                fieldKey: 3,
                fieldName: "seconds",
                deprecated: false,
                pointerRules: NoPointers,
            }, "non-negative", "seconds"),
        };
    }
}
